import React from "react";
import { post } from "../fetchData";

const useFetchFaqDetail = (id:any) => {
  const [data, setFaq] = React.useState<any>({});
  const [loading, setLoading] = React.useState(false);
  const [loaded, setLoaded] = React.useState(false);

  React.useEffect(() => {
    listFaq();
  }, []);

  const listFaq = () => {
    setLoading(true);
    setLoaded(false);
 post( { id:id }, "get_faq_details").then(
        (result) => {
          setLoading(false);
          console.log(result);
            setFaq(result?.status ? result : {});
        },
        (error) => {
          setFaq({});
        }
      )
      .finally(() => {
        setLoading(false);
        setLoaded(false);
      }); //fetch
  }; //doAjax

  return {data,loading,loaded};
};

export default useFetchFaqDetail;
